// Modal sederhana. Aturan §2 (terkunci): popup TIDAK tertutup saat klik latar —
// keluar hanya lewat tombol .x / Batal / Simpan / Konfirmasi. Klik backdrop diabaikan.
import { enhanceTables } from './table';

// ── Rantai popup (tombol ← Kembali) ────────────────────────────────────────
// Backdrop popup menutupi tombol Back di topbar (feedback Apo) → tiap popup dapat ←
// sendiri di header. Popup yang dibuka dari popup lain menerima `onBack` (thunk yang
// membuka lagi induknya) SECARA EKSPLISIT via opts — bukan state global — supaya
// bebas-race (tak bisa "dicuri" modal lain saat gap fetch) & benar saat masuk-ulang.
export function openModal(innerHtml: string, opts?: { onBack?: () => void }): HTMLElement {
  const back = opts?.onBack;
  const bg = document.createElement('div');
  bg.className = 'modal-bg';
  bg.innerHTML = `<div class="modal">${innerHtml}</div>`;
  const modal = bg.querySelector('.modal') as HTMLElement;
  const head = bg.querySelector('.modal-head') as HTMLElement | null;
  const x = bg.querySelector('.x');
  // Nama aksesibel dipasang terpusat: "×" saja tak terbaca pembaca layar, dan ada ~60 tombol
  // seperti ini tersebar di seluruh aplikasi — memasangnya di sini menutup semuanya sekaligus.
  if (x) { if (!x.getAttribute('aria-label')) x.setAttribute('aria-label', 'Tutup'); x.addEventListener('click', () => bg.remove()); }
  // Tombol ← Kembali SELALU ada di tiap popup (feedback Apo — backdrop menutupi Back topbar):
  // berantai → tutup + buka popup induk; top-level → tutup (reveal menu di baliknya).
  if (head) {
    const bk = document.createElement('button');
    bk.className = 'modal-back'; bk.innerHTML = '←'; bk.title = back ? 'Kembali ke sebelumnya' : 'Kembali / tutup';
    bk.addEventListener('mousedown', (e) => e.stopPropagation()); // jangan drag header
    bk.addEventListener('click', (e) => { e.stopPropagation(); bg.remove(); if (back) back(); });
    head.insertBefore(bk, head.firstChild);
  }
  // Semua pop-up: bisa dibesar-kecilkan/dilebarkan (⤢ + resize CSS pojok) & dipindah (drag header).
  if (head && modal) {
    const mx = document.createElement('button');
    mx.className = 'mmax'; mx.innerHTML = '⤢'; mx.title = 'Perbesar / kecilkan';
    mx.addEventListener('mousedown', (e) => e.stopPropagation());
    mx.addEventListener('click', (e) => {
      e.stopPropagation();
      modal.classList.toggle('maximized');
      if (!modal.classList.contains('maximized')) { modal.style.width = ''; modal.style.height = ''; }
    });
    if (x) head.insertBefore(mx, x); else head.appendChild(mx);
    head.addEventListener('mousedown', (e: MouseEvent) => {
      if ((e.target as HTMLElement).closest('button')) return; // jangan drag saat klik tombol header
      const rect = modal.getBoundingClientRect();
      const offX = e.clientX - rect.left, offY = e.clientY - rect.top;
      modal.style.position = 'fixed'; modal.style.margin = '0'; modal.style.left = rect.left + 'px'; modal.style.top = rect.top + 'px';
      const mv = (ev: MouseEvent): void => { modal.style.left = Math.max(0, ev.clientX - offX) + 'px'; modal.style.top = Math.max(0, ev.clientY - offY) + 'px'; };
      const up = (): void => { document.removeEventListener('mousemove', mv); document.removeEventListener('mouseup', up); };
      document.addEventListener('mousemove', mv); document.addEventListener('mouseup', up);
    });
  }
  document.body.appendChild(bg);
  enhanceTables(bg); // tabel di popup juga: header klik-sort + lebar kolom drag
  return bg;
}
